<template>
<w-tool-tabs class="tab-button" size="mini" v-model="activeTab">
  <el-row slot="tool" type="flex" justify="end">
    <w-config-edit-tool class="mr-r4" v-show="visibleEditButton"></w-config-edit-tool>
    <!-- 그룹 저장 -->
    <div>
      <el-button v-show="!isConfigEditing && visibleEditButton" type="secondary" size="small" @click="openGroupSavePopup">그룹 저장</el-button>
      <w-group-save-popup ref="groupSavePopup" :selected-obj="selectedNode" :config-data="configData" />
    </div>
  </el-row>
  <el-tab-pane label="구성 현황" name="WConfigStatus" >
    <w-wireless-ap-config-status :nodeParams="nodeParams" @setConfigData="setConfigData"/>
  </el-tab-pane>
  <el-tab-pane v-if="isStandalone" label="인터페이스 정보" name="WInterfaceInfoNode">
    <w-interface-info-node :activeTab="activeTab" :nodeParams="nodeParams"></w-interface-info-node>
  </el-tab-pane>
  <el-tab-pane v-if="isStandalone" label="변경이력" name="WChangeHistView">
    <w-change-hist-view :titleName="titleName" :activeTab="activeTab" :nodeParams="nodeParams"></w-change-hist-view>
  </el-tab-pane>
  <el-tab-pane v-if="isStandalone" label="컨피그 정보" name="WConfigInfoNode">
    <w-config-info-node :activeTab="activeTab" :nodeParams="nodeParams"></w-config-info-node>
  </el-tab-pane>
  <el-tab-pane v-if="isStandalone" label="스크립트 수행이력" name="WScriptExecuteHistNode">
    <w-script-execute-hist-node :activeTab="activeTab" :nodeParams="nodeParams"></w-script-execute-hist-node>
  </el-tab-pane>
</w-tool-tabs>
</template>

<script>
import { mapGetters } from 'vuex';
import netdeviceInfoAPI from '@/api/config/netdevice/netdevice-info';
import isNil from 'lodash/isNil';
import ConfigNodeTab from '@/mixins/config/config-node-tab';
import WScriptExecuteHistNode from '@/views/config/node/netdevice/scriptexecutehist';
import WConfigInfoNode from '@/views/config/node/netdevice/config';
import WInterfaceInfoNode from '@/views/config/node/netdevice/interface';
import WWirelessApConfigStatus from './configstatus';
import WChangeHistView from '../common/ChangeHistView';

export default {
  name: 'WConfigWirelessApNode',
  components: {
    WWirelessApConfigStatus,
    WChangeHistView,
    WScriptExecuteHistNode,
    WConfigInfoNode,
    WInterfaceInfoNode,
  },
  mixins: [ConfigNodeTab],
  data() {
    return {
      activeTab: 'WConfigStatus',
      titleName: '무선네트워크장비',
      nodeParams: {},
      params: {
        objId: null,
      },
      isCiscoNode: false,
      configData: {},
    };
  },
  computed: {
    /**
     * Standalone AP 여부
     * @author Ju
     * @return {Boolean}
     */
    isStandalone() {
      return isNil(this.selectedNode) || isNil(this.selectedNode.obj.parentObjId);
    },
    ...mapGetters(['selectedNode']),
  },
  watch: {
    selectedNode: {
      handler() {
        if (!this.active) {
          return;
        }
        if (!isNil(this.selectedNode)) {
          this.params.objId = this.selectedNode.obj.objId;
          this.loadParams();
        }
      },
      immediate: true,
    },
    active(active) {
      if (active) {
        this.params.objId = this.selectedNode.obj.objId;
        this.loadParams();
      }
    },
    isStandalone: {
      immediate: true,
      handler(value) {
        if (!value && this.activeTab !== 'WConfigStatus') {
          this.activeTab = 'WConfigStatus';
        }
      },
    },
  },
  methods: {
    loadParams() {
      if (!isNil(this.params.objId)) {
        // TODO api 확인
        netdeviceInfoAPI.getNetdeviceObjInfo(this.params).then((result) => {
          if (result.data.success) {
            this.nodeParams = result.data.data;
          }
        });
      }
    },
    /**
     * 그룹 저장시 데이터 비교할 구성정보 데이터를 바인딩한다.
     * @param  {[type]} configData [description]
     * @author jda
     */
    setConfigData(configData) {
      this.configData = configData;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/config/node/wireless-ap/index.vue